import React from 'react';
import { makeStyles } from '@material-ui/core';
import FixedLayout from './FixedLayout'


const useStyles = makeStyles((theme) => ({
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  columnStyle: {
    maxHeight: '100%',
    overflowY: 'auto',
    marginTop: '8px',
  }
}));

interface Props {
  window?: any;
  title?: string;
  drawer?: any;
  children: React.ReactNode;
}

export default function ColumnLayout(props: Props) {
  const classes = useStyles();
  return (
    <FixedLayout>
      <div className={classes.columnStyle}>
        {props.children}
      </div>
    </FixedLayout>
  );
}
